// extracted by mini-css-extract-plugin
module.exports = {"DSLogo":"dsLogo_DSLogo__1dV0V","headerLogo":"dsLogo_headerLogo__3S3fw","DSLogoActiveLink":"dsLogo_DSLogoActiveLink__3ncM6","DSLogoHeader":"dsLogo_DSLogoHeader__J8MJ1"};